import { Group, Text, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import BikePackageIcon from '@/assets/icons/bike-package-icon.svg';

const TruckPackageHeader = () => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  // const { bikePackageSize, bikePackageWeight, itemDescriptions } =
  //   useBookingStore((state) => state);

  return (
    <Group
      style={{ padding: '8px 12px' }}
      className="relative w-full"
      gap={4}
      wrap="nowrap"
    >
      <BikePackageIcon className="size-6 md:size-8" viewBox="0 0 32 32" />

      <Title
        order={isMobile ? 6 : 4}
        style={{
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        <Text fw={700} size={isMobile ? 'sm' : 'lg'}>
          Thông tin hàng hóa
          {/* <Text component="span" c="red">
                  *
                </Text> */}
        </Text>
      </Title>
    </Group>
  );
};

export default TruckPackageHeader;
